import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { useSelector } from 'react-redux';
import { selectFigmaConnected } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';
import { openFigmaAuthPopup } from 'utils';

interface Props {
	label: string;
}

const ConnectFigmaAction = ({ label }: Props) => {
	const figmaConnected = useSelector((r: RootReducer) => selectFigmaConnected(r.db));

	const onClick = async () => {
		if (figmaConnected) return;
		await openFigmaAuthPopup();
	};

	return (
		<ActionButton
			icon={figmaConnected ? IconType.CONNECTED : IconType.EXTERNAL}
			label={figmaConnected ? 'Connected to Figma' : label}
			onClick={onClick}
		/>
	);
};

export default ConnectFigmaAction;
